<template>
    <div class="grid grid-nogutter justify-content-between">
        <div class="col-12 p-2">
            <div class="surface-section border-round shadow-1 p-4 flex flex-column gap-2 h-full">
                <div class="flex justify-content-between align-items-start">
                    <div class="flex gap-3 align-items-center flex-1">
                        <img :src="feedback.photoURL ? feedback.photoURL : blankProfile" class="h-3rem w-3rem border-circle" />
                        <div class="flex flex-column flex-1">
                            <span class="font-semibold whitespace-nowrap overflow-hidden text-overflow-ellipsis">
                                {{ feedback.studentName }}
                            </span>
                            <span
                                class="text-color-secondary text-sm mt-1 whitespace-nowrap overflow-hidden text-overflow-ellipsis">
                                {{ cleanupLables(feedback.studentGrade) }}
                            </span>
                        </div>
                    </div>
                    <div class="flex flex-column align-items-end flex-none">
                        <div class="flex gap-1">
                            <i v-for="n in 5" :key="n" class="pi pi-star"
                                :class="n <= feedback.rating ? 'text-yellow-500' : 'text-400'"></i>
                        </div>
                        <span class="text-color-secondary text-sm mt-1">{{ feedback.created_at }}</span>
                    </div>
                </div>
                <Divider class="w-full" />
                <div class="Label">Review for - {{ feedback.tutorName }}</div>
                <Textarea v-model="editableReview.review" rows="4" class="w-full" />
                <Divider class="w-full" />
                <div class=" flex flex-wrap justify-content-start align-items-center gap-2">
                    <span class="Label">Hide</span>
                    <InputSwitch v-model="editableReview.published" />
                    <span class="Label">Publish</span>
                </div>
                <div class="flex justify-content-end gap-4 mt-6">
                    <Button label="Update" class="accent-button"  @click="emitUpdate" />
                    <Button label="Cancel" class="accent-button-transparent" @click="$emit('go-back')" />
                </div>
            </div>

        </div>
    </div>
</template>
<script setup>
import Divider from "primevue/divider";
import { defineProps,watch,ref,defineEmits } from "vue";
import Textarea from "primevue/textarea";
import InputSwitch from "primevue/inputswitch";
import Button from "primevue/button";
import blankProfile from '@/assets/blank-profile.png';
import { cleanupLables } from "@/utils/cleanups";
const props = defineProps({
    feedback: null
})
const emit = defineEmits(["go-back", "update-review"]);

const editableReview = ref({
  review: props.feedback.review,
  published: props.feedback.published,
});


watch(
  () => props.feedback,
  (newVal) => {
    editableReview.value = {
      review: newVal.review,
      published: newVal.published,
    };
  }
);

const emitUpdate = () => {
  emit("update-review", {
    id: props.feedback._id,
    review: editableReview.value.review,
    published: editableReview.value.published,
  });
};
</script>